var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm._l(_vm.inputSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v("Input Search")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: form.value,
                          expression: "form.value"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: form.id,
                        placeholder: form.name
                      },
                      domProps: { value: form.value },
                      on: {
                        keyup: _vm.textKeyupEvent,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(form, "value", $event.target.value)
                        }
                      }
                    })
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav mg-t-35-f" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v("Date Search")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-block",
                      attrs: { for: "formGroupExampleInput" }
                    },
                    [_vm._v(_vm._s(form.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("date-picker", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.datePickerOptions,
                          autocomplete: "off",
                          placeholder: "From date",
                          id: form.fid,
                          "aria-label": "Search",
                          ignoreReadonly: ""
                        },
                        on: { "dp-change": _vm.dateKeyupEvent },
                        model: {
                          value: form.fvalue,
                          callback: function($$v) {
                            _vm.$set(form, "fvalue", $$v)
                          },
                          expression: "form.fvalue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("date-picker", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.datePickerOptions,
                          autocomplete: "off",
                          placeholder: "To date",
                          id: form.eid,
                          "aria-label": "Search",
                          ignoreReadonly: ""
                        },
                        on: { "dp-change": _vm.dateKeyupEvent },
                        model: {
                          value: form.evalue,
                          callback: function($$v) {
                            _vm.$set(form, "evalue", $$v)
                          },
                          expression: "form.evalue"
                        }
                      })
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c(
                  "ul",
                  { staticClass: "sidebar-nav mg-t-35-f" },
                  [
                    i === 0
                      ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                          _vm._v("Checkbox Search")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: " d-block",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _vm._l(form.subs, function(form1, i) {
                      return _c(
                        "div",
                        {
                          staticClass: "custom-control custom-checkbox mg-b-7",
                          attrs: { id: form.id }
                        },
                        [
                          _c("input", {
                            staticClass: "custom-control-input",
                            attrs: { type: "checkbox", id: form1.codeCode },
                            domProps: { value: form1.codeCode },
                            on: { click: _vm.checkClickEvent }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-control-label",
                              attrs: { for: form1.codeCode }
                            },
                            [_vm._v(_vm._s(form1.codeName))]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName) + " List")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " List")
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row row-xs" }, [
            _c("div", { staticClass: "col-lg-12 mg-t-10" }, [
              _c(
                "section",
                [
                  _c(
                    "b-field",
                    { attrs: { grouped: "", "group-multiline": "" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { disabled: !_vm.isPaginated },
                          model: {
                            value: _vm.perPage,
                            callback: function($$v) {
                              _vm.perPage = $$v
                            },
                            expression: "perPage"
                          }
                        },
                        [
                          _c("option", { attrs: { value: "20" } }, [
                            _vm._v("20")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "50" } }, [
                            _vm._v("50")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "100" } }, [
                            _vm._v("100")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "200" } }, [
                            _vm._v("200")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "b-table",
                    {
                      attrs: {
                        data: _vm.isEmpty ? [] : _vm.data,
                        loading: _vm.loading,
                        paginated: "",
                        hoverable: "",
                        striped: "",
                        "backend-pagination": "",
                        total: _vm.total,
                        "per-page": _vm.perPage,
                        "aria-next-label": "Next page",
                        "aria-previous-label": "Previous page",
                        "aria-page-label": "Page",
                        "aria-current-label": "Current page",
                        "backend-sorting": "",
                        "default-sort": [_vm.sortField, _vm.sortOrder]
                      },
                      on: { "page-change": _vm.onPageChange, sort: _vm.onSort },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(props) {
                            return _vm._l(_vm.headers, function(form, i) {
                              return form.columnAttr == "runid"
                                ? _c(
                                    "b-table-column",
                                    {
                                      key: i,
                                      attrs: {
                                        field: form.columnAttr,
                                        label: form.columnName,
                                        centered: "",
                                        sortable: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.classifySample(
                                                props.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(props.row[form.columnAttr])
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "b-table-column",
                                    {
                                      key: i,
                                      attrs: {
                                        field: form.columnAttr,
                                        label: form.columnName,
                                        centered: "",
                                        sortable: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(props.row[form.columnAttr]) + " "
                                      )
                                    ]
                                  )
                            })
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered"
                            },
                            [_c("p", [_vm._v("Nothing here.")])]
                          )
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c("div", { staticClass: "row row-xs" }, [
            _c("div", { staticClass: "col-lg-12 mg-t-10" }, [
              _c("section", [
                _vm.datacolumns.length > 0
                  ? _c("div", { staticClass: "d-none d-md-block tx-right-f" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-animation": "effect-flip-horizontal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.excelExport()
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass:
                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                            attrs: { type: "file-text" }
                          }),
                          _vm._v("Excel")
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.datacolumns.length > 0
                  ? _c(
                      "ul",
                      {
                        staticClass: "nav nav-line",
                        attrs: { id: "myTab5", role: "tablist" }
                      },
                      _vm._l(_vm.tabHeaders, function(form, i) {
                        return _vm.properties.mid === form.id
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link active",
                                  attrs: {
                                    id: form.id,
                                    "data-toggle": "tab",
                                    href: "#",
                                    role: "tab",
                                    "aria-controls": "home",
                                    "aria-selected": "true"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.classifySampleHeader(
                                        form.id,
                                        form.jobOrder
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(form.menuName))]
                              )
                            ])
                          : _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    id: form.id,
                                    "data-toggle": "tab",
                                    href: "#",
                                    role: "tab",
                                    "aria-controls": "profile",
                                    "aria-selected": "false"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.classifySampleHeader(
                                        form.id,
                                        form.jobOrder
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(form.menuName))]
                              )
                            ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "white-space": "nowrap",
                      "overflow-x": "scroll"
                    }
                  },
                  [
                    _c("b-table", {
                      attrs: {
                        data: _vm.items,
                        hoverable: "",
                        striped: "",
                        paginated: "",
                        "per-page": "15"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(props) {
                            return _vm._l(_vm.datacolumns, function(form, i) {
                              return form.field == "receptionno"
                                ? _c(
                                    "b-table-column",
                                    {
                                      key: i,
                                      attrs: {
                                        field: form.field,
                                        label: form.label,
                                        centered: "",
                                        sortable: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#modal52",
                                            "data-toggle": "modal",
                                            "data-animation":
                                              "effect-flip-horizontal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.sendId(
                                                props.row.receptionId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row[form.field]) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "b-table-column",
                                    {
                                      key: i,
                                      attrs: {
                                        field: form.field,
                                        label: form.label,
                                        centered: "",
                                        sortable: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row[form.field]))]
                                  )
                            })
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal52",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel52",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("h5", [_vm._v("Search")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
        _c("i", { attrs: { "data-feather": "x" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel52" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f8381f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8381f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Sequencing/RunInfo/List2.vue
// module id = null
// module chunks = 